import { Component, ModuleWithComponentFactories, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth/auth.service";
import { environment } from "src/environments/environment";
import { TrataExcessao } from "../../utils/trata-excessao";
import { CustomSnackBarService } from "../custom-snack-bar/custom-snack-bar.service";
import packageInfo from 'package.json';
import { GlobalVariables } from "../../utils/global-variables.service";
import { ConfigService } from "../../services/config/config-service";

@Component({
  selector: "app-sidemenu",
  templateUrl: "./sidemenu.component.html",
  styleUrls: ["./sidemenu.component.css"],
})
export class SidemenuComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    private globalVariables: GlobalVariables,
    private snackBar: CustomSnackBarService,
    public configService: ConfigService
  ) {

  }

  isLoading = false;
  ambiente: string;
  versao = packageInfo.version;
  indLogoEmpresa: boolean = false;

  menu = [{}];

  ngOnInit() {
    this.ambiente = this.configService.getEnvProp('nome');
    this.indLogoEmpresa = environment?.indLogoEmpresa ?? false;
    this.buscarEstruturaMenu();
  }

  public get auth()
  {
    return this.authService;
  }

  buscarEstruturaMenu()
  {
    
    this.isLoading = true;
  
  
    this.authService.buscaEstruturaMenu().subscribe({
      next: (response) => {
        this.isLoading = false;
        this.montaMenu(response.body.retorno);
      },
      error: (err) => {
        this.isLoading = false;
        TrataExcessao.TrataExcessao(err, this.authService,this.snackBar);
      }
    });

  }

  private montaMenu(retorno: any)
  {
    var menu:any = [];
    retorno.modulo.forEach(modulo => {
      var menuItem = {
        label: modulo.nomeModulo,
        icon: "",
        id: modulo.siglaModulo,
        items: []
      };
      modulo.programa.forEach(programa => {
        var item:any =
        {
          label: programa.nomePrograma,
          icon: programa.iconePrograma,
          link: programa.caminhoPrograma,
        }
        menuItem.items.push(item as never);
      });

      menu.push(menuItem);

    });

    this.authService.setEstruturaMenu(menu);
    this.menu = menu;
  }

  config = {
    paddingAtStart: true,
    classname: "my-custom-class",
    fontColor: "#fff",
    selectedListFontColor: "#ffffff",
    interfaceWithRoute: true,
    collapseOnSelect: true,
    highlightOnSelect: true,
  };

  selectedItem(event) {
    if (event.link == "/logout") {
      this.authService.logout();
      return;
    }
    this.globalVariables.telaAtiva = event.label;
    this.router.navigate(["/" + event.link]);
  }
}
